import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-position-medals',
  templateUrl: './position-medals.component.html',
  styleUrls: ['./position-medals.component.scss']
})
export class PositionMedalsComponent implements OnInit {

  /**
   * The input of the rank for show medals or ordinal numbers.
   *
   * @type {(number|string)}
   * @memberof PositionMedalsComponent
   */
  @Input()
  Rnk:number;
  constructor() { }

  ngOnInit() {
  }

}
